<template>
  <div class="wrapper">
    <h1 class="mb4">Login</h1>
    <m-input v-model="user.username" label="Username" class="mb3"></m-input>
    <m-input v-model="user.password" type="password" label="Password"></m-input>
    <m-button class="mt4">Login</m-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: {
        username: null,
        password: null,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
}
</style>
